import './front/components/Breadcrumbs/lifecycle';
import './front/components/Details/lifecycle';
import './front/components/Dropdown/lifecycle';
import './front/components/Tag/lifecycle';
import './front/components/Tooltip/lifecycle';
import './front/components/Burger/lifecycle';
import './front/components/Navigation/lifecycle';
import './front/components/Navigation/sticky';
import './front/components/Gallery/lifecycle';
import './front/components/Comparator/lifecycle';
import './front/components/Comparator/Api_diplome';
import './front/components/ConditionalLogic/lifecycle';
import './front/components/Repeater/lifecycle';
import './front/components/Datalayer/datalayer';
import './front/components/Charts/Donut';
import './front/components/Charts/VerticalBar';
import './front/components/Charts/HorizontalBar';
import './front/components/Charts/MobileMessage';
import './front/components/tabs';
import './front/components/summary';
import './front/components/banner';
import './front/components/old-post';
import './front/utilities/form-validation';
console.log('coucou')
